import { useEffect, useState } from "react"
import "./scroll-hint.css"

const ScrollHint = () => {
	const [showHint, setShowHint] = useState(true)

	useEffect(() => {
		const hideHint = () => setShowHint(false)

		window.addEventListener("scroll", hideHint, { once: true })

		// Auto-hide dopo 4 secondi se non scrolla
		const timeout = setTimeout(() => setShowHint(false), 4000)

		return () => {
			window.removeEventListener("scroll", hideHint)
			clearTimeout(timeout)
		}
	}, [])

	if (!showHint) return null

	return (
		<div className="scroll-hint-overlay">
			<div className="scroll-hint-text">
				Scroll per caricare altri elementi{" "}
				<div className="scroll-hint-chevron">
					<span className="chevron">⌄</span>
				</div>
			</div>
		</div>
	)
}

export default ScrollHint
